import React, {useCallback} from 'react';

import {ActionPlanImpactLevel, CategoryKeyEnum} from '#apollo/schema';
import {Icon, Text} from '#component/base';
import {ImpactImage} from '#component/page/ActionPlan/components/ImpactImage';
import {ImpactTag} from '#component/page/ActionPlan/components/ImpactTag';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';
import {sprinkles} from '#style/sprinkles';
import {getCategoryIconName} from '#util';

export interface GoalsHeaderProps {
  title: string;
  subtitle: string;
  healthFactorId?: string;
  impactLevel?: ActionPlanImpactLevel;
  categoryKey: CategoryKeyEnum;
  imageUrl?: string;
  onClick?: () => void;
}

function GoalsHeader({
  title,
  subtitle,
  healthFactorId,
  categoryKey,
  impactLevel,
  imageUrl,
}: GoalsHeaderProps) {
  const {track} = useAnalytics();
  const [open, setOpen] = React.useState(false);

  const onClick = useCallback(() => {
    if (healthFactorId && !open) {
      track<UserActionEvent>({
        evtName: EventType.UserAction,
        actionName: 'AP Goal - Drop Down',
        data: {
          healthFactorId,
        },
      });
    }
    setOpen(open => !open);
  }, [healthFactorId, open, track]);

  return (
    <div
      className={sprinkles({
        display: 'flex',
        items: 'center',
        w: 'full',
      })}
      onClick={onClick}>
      <div
        className={sprinkles({
          display: 'flex',
          items: 'center',
          gap: 40,
          w: 'full',
        })}>
        <ImpactImage imageUrl={imageUrl} impactLevel={impactLevel} />
        <div
          className={sprinkles({
            w: 'full',
          })}>
          <Text
            as="p"
            color="deepBurgundy"
            variant="body"
            fontWeight="regular"
            className={sprinkles({
              display: 'flex',
              gap: 12,
              items: 'center',
            })}>
            <Icon
              name={getCategoryIconName(categoryKey)}
              color="eggplantDark"
              className={sprinkles({
                mR: 4,
              })}
            />
            {title}
          </Text>
          <Text
            as="p"
            variant="bodyLarge"
            fontWeight="regular"
            style={{
              maxWidth: '80%',
              textAlign: 'left',
            }}>
            {subtitle}
          </Text>
        </div>
      </div>
      <div
        className={sprinkles({
          mL: 'auto',
          display: 'flex',
          items: 'center',
          gap: 32,
          w: 'maxContent',
          mR: 32,
        })}>
        <ImpactTag impactLevel={impactLevel} />
        <Text
          color="eggplantDark"
          variant="buttonSmall"
          fontWeight="semiBold"
          style={{
            whiteSpace: 'nowrap',
          }}>
          Explore goal
        </Text>
      </div>
    </div>
  );
}

export {GoalsHeader};
